<template>
  <PrmSidebar
    :visible="visible"
    class="app-sidebar"
    @update:visible="emit('update:visible', $event)"
  >
    <slot />
  </PrmSidebar>
</template>

<script lang="ts" setup>
import PrmSidebar from '@NitrexGroup/primevue/sidebar';

defineProps<{
  visible: boolean,
}>();

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void,
}>();
</script>

<style lang="scss">
@use '../../styles/z-index.scss';

.app-sidebar {
  padding: env(safe-area-inset-top) 0 0 env(safe-area-inset-left);
  z-index: z-index.$app-sidebar;
}
</style>
